var exports = {
  "k": "x112a1f60--30a6b5--container",
};

module.exports = exports;
